import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { tableConfig } from '../../../../../settings/index';
import { sendRequest } from '../../../../../helpers/saga';
import { logger } from '../../../../../helpers/logger';
import notifications from '../../../../../redux/notifications/actions';
import Api from '../../../../../helpers/api';

const api = new Api('workers/:id/referrals');

function* loadData({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '', id } = payload;

    const result = yield call(
      sendRequest,
      api.load,
      { search: { page, pageSize, column, order, filter }, id },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const { referrals, referrer, totalCount, filteredCount, sortable_columns } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          data: { referrals, referrer },
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns: sortable_columns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData)]);
}
